import { FC } from 'react';

import { useTranslation } from 'react-i18next';
import { GridColDef } from '@mui/x-data-grid';

import { Table } from 'src/components';
import { YardType } from 'src/types';

import { TableProps } from '../Table';

export const yardsColumnVisibilityModel = {
  yardName: false,
  country: false,
  street: false,
  city: false,
  state: false,
  zip: false,
  createdBy: false,
};

type YardsTableProps = {
  yards: YardType[];
  isEditable?: boolean;
} & Partial<TableProps>;

const YardsTable: FC<YardsTableProps> = ({ yards, isEditable = false, ...props }): JSX.Element => {
  const { t } = useTranslation();

  const columns: GridColDef[] = [
    {
      field: 'name',
      headerName: t('companyYardsPage.yardName'),
      editable: isEditable,
      minWidth: 160,
    },
    {
      field: 'country',
      headerName: t('companyYardsPage.country'),
      editable: isEditable,
      minWidth: 160,
    },
    {
      field: 'street',
      headerName: t('companyYardsPage.street'),
      editable: isEditable,
      minWidth: 160,
    },
    {
      field: 'city',
      headerName: t('companyYardsPage.city'),
      editable: isEditable,
      minWidth: 160,
    },
    {
      field: 'state',
      headerName: t('companyYardsPage.state'),
      editable: isEditable,
      minWidth: 160,
    },
    {
      field: 'zipCode',
      headerName: t('companyYardsPage.zip'),
      editable: isEditable,
      minWidth: 160,
    },
    {
      field: 'created',
      headerName: t('companyYardsPage.createdBy'),
      editable: isEditable,
      minWidth: 160,
    },
  ];

  return <Table {...props} type="advanced" columns={columns} rows={yards} getRowId={(row) => row.id} disableRowSelectionOnClick />;
};

export default YardsTable;
